<template>
    <div ref="wrapper" class="relative block transition-all duration-300" :class="{ 'pl-5': props.errors.length }">
        <div
            class="absolute inset-y-0 left-0 w-1.5 origin-left scale-x-0 rounded-full transition"
            :class="{ 'scale-x-100 bg-rose-500': props.errors.length }"
        ></div>

        <animate-height :height="props.errors.length ? 'auto' : 0">
            <div
                class="mb-3 flex flex-col gap-1 transition-opacity duration-300"
                :class="{ 'opacity-0': !props.errors.length }"
            >
                <template v-for="error in props.errors" :key="error">
                    <slot name="alert" :error="error">
                        <vx-alert color="danger" :closeable="false">
                            <template v-slot:icon>
                                <font-awesome-icon :icon="faTriangleExclamation" widthAuto></font-awesome-icon>
                            </template>
                            {{ error }}
                        </vx-alert>
                    </slot>
                </template>
            </div>
        </animate-height>

        <div>
            <slot></slot>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { ref, watch, nextTick } from 'vue';
import { VxAlert } from '@voxie/frontend-components';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';
import AnimateHeight from 'vue-animate-height';

const props = withDefaults(defineProps<{ errors?: string[]; autoFocus?: boolean }>(), {
    errors: () => [],
    autoFocus: false,
});

const wrapper = ref<HTMLDivElement | null>(null);

watch(
    () => props.errors.length,
    async (newLength: number, oldLength: number) => {
        const focusableElements = wrapper.value?.querySelectorAll<HTMLElement>(
            'input:not([disabled]), textarea:not([disabled]), select:not([disabled])'
        );

        if (newLength > 0) {
            focusableElements?.forEach((el) => {
                el.setAttribute('aria-invalid', 'true');
            });

            if (props.autoFocus && oldLength === 0) {
                await nextTick();
                focusableElements?.[0]?.focus();
            }
        }

        if (newLength === 0) {
            focusableElements?.forEach((el) => {
                el.removeAttribute('aria-invalid');
            });
        }
    }
);
</script>
